// Floating wishlist button: appears once the page is scrolled and opens the Swym wishlist drawer.
(() => {
  const launcher = document.querySelector('[js-wishlist-launcher]');
  if (!launcher) return;

  const SHOW_AFTER = 200;
  const update = () => {
    launcher.hidden = window.scrollY < SHOW_AFTER;
  };

  launcher.addEventListener('click', () => {
    if (window._swat?.ui?.open) {
      window._swat.ui.open();
    } else {
      window.location.hash = 'swym-list';
    }
  });

  window.addEventListener('scroll', update, { passive: true });
  update();
})();
